import { VoiceAgentVoice } from "@jugl-web/rest-api";

export enum VoiceAccountMenuTab {
  general = "general",
  transferCalls = "transferCalls",
  howItWorks = "howItWorks",
}

export type VoiceGeneralFormValues = {
  use_base_instructions: boolean;
  instructions: string;
  welcome_message: string;
  voice: VoiceAgentVoice;
  daily_calls_limit: number | null;
  max_call_duration_min: number;
  max_concurrent_calls: number;
};

export type VoiceTransferFormValues = {
  transfer_enabled: boolean;
  transfer_number: string | null;
  when_to_handover: string;
};
